import { http } from '@/utils/http'
export const QCBASE = window.$envUtils('VUE_APP_QC_SERVICE')

/**
 * 查询任务列表
 * @param {*} params
 */
export const taskList = (params) => {
  return http.get(`${QCBASE}/mgr/task/qcTask`, { params })
}

/**
 *新增任务
 * @param {*} params
 */
export const saveTask = (data) => {
  return http.post(`${QCBASE}/mgr/task/qcTask`, { data }, function () {})
}

/**
 *删除任务
 * @param {*} params
 */
export const deleteTask = (params) => {
  return http.delete(`${QCBASE}/mgr/task/qcTask/` + params)
}

/**
 * 通过id查询任务
 * @param {*} params
 */
export const getTaskById = (params) => {
  return http.get(`${QCBASE}/mgr/task/qcTask/` + params)
}
/**
 *修改任务
 * @param {*} params
 */
export const updateTask = (data) => {
  return http.put(`${QCBASE}/mgr/task/qcTask`, { data }, function () {})
}

/**
 *修改任务状态
 * @param {*} params
 */
export const updateTaskStatus = (data) => {
  return http.put(`${QCBASE}/mgr/task/qcTaskStatus`, { data }, function () {})
}

/**
 *查询所有质检方案
 */
export const allQcPlan = () => {
  return http.get(`${QCBASE}/mgr/task/qcTask/allQcPlan`)
}

/**
 *通过质检方案id获取质检项
 */
export const getQcItemsByPlanId = (params) => {
  return http.get(`${QCBASE}/mgr/plan/qcItems/` + params)
}

/**
 * 通过id测试任务
 * @param {*} params
 */
export const testTaskById = (params) => {
  return http.get(`${QCBASE}/mgr/task/qcTask/testTask/` + params)
}
